// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */

.AdminNavigation-adminHeaderWrapper-YY1iA {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.AdminNavigation-adminHeaderList-cmTui a,
.AdminNavigation-adminDropDownHeaderList-XJLNi,
.AdminNavigation-logoutAdminHeaderList-a62g0 {
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  color: var(--primary-foreground);
  text-decoration: none;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  background: unset;
  outline: unset;
  border: unset;
  padding: 0;
}

.AdminNavigation-adminHeaderList-cmTui a,
.AdminNavigation-adminHeaderList-cmTui a:hover,
.AdminNavigation-adminHeaderList-cmTui a:focus,
.AdminNavigation-adminHeaderList-cmTui a:active {
  color: var(--primary-foreground);
  text-decoration: none;
}

.AdminNavigation-languageDropdownSelected-kqEMr {
  color: var(--secondary-bg);
}

.AdminNavigation-adminHeaderListIcon-xw5aR {
  width: 20px;
  height: 20px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.AdminNavigation-adminHeaderListIcon-xw5aR svg {
  width: 100%;
  height: 100%;
}

@media (max-width:767px) {
  .AdminNavigation-adminHeaderListText-Dsk3F {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/AdminNavigation/AdminNavigation.css"],"names":[],"mappings":"AAAA,QAAQ;;AAER;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;EACZ,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAGA;;;EAGE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAGA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* new */\n\n.adminHeaderWrapper {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  justify-content: flex-end;\n  gap: 24px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n\n.adminHeaderList a,\n.adminDropDownHeaderList,\n.logoutAdminHeaderList {\n  font-size: 15px;\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--primary-foreground);\n  text-decoration: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: unset;\n  outline: unset;\n  border: unset;\n  padding: 0;\n}\n\n.adminHeaderList a,\n.adminHeaderList a:hover,\n.adminHeaderList a:focus,\n.adminHeaderList a:active {\n  color: var(--primary-foreground);\n  text-decoration: none;\n}\n\n.languageDropdownSelected {\n  color: var(--secondary-bg);\n}\n\n.adminHeaderListIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.adminHeaderListIcon svg {\n  width: 100%;\n  height: 100%;\n}\n\n\n@media (max-width:767px) {\n  .adminHeaderListText {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminHeaderWrapper": `AdminNavigation-adminHeaderWrapper-YY1iA`,
	"adminHeaderList": `AdminNavigation-adminHeaderList-cmTui`,
	"adminDropDownHeaderList": `AdminNavigation-adminDropDownHeaderList-XJLNi`,
	"logoutAdminHeaderList": `AdminNavigation-logoutAdminHeaderList-a62g0`,
	"languageDropdownSelected": `AdminNavigation-languageDropdownSelected-kqEMr`,
	"adminHeaderListIcon": `AdminNavigation-adminHeaderListIcon-xw5aR`,
	"adminHeaderListText": `AdminNavigation-adminHeaderListText-Dsk3F`
};
module.exports = ___CSS_LOADER_EXPORT___;
